import { render } from "./video_control.vue?vue&type=template&id=5fa92d83&scoped=true"
import script from "./video_control.vue?vue&type=script&lang=js"
export * from "./video_control.vue?vue&type=script&lang=js"

import "./video_control.vue?vue&type=style&index=0&id=5fa92d83&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa92d83"],['__file',"Scripts/components/control/video_control.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fa92d83"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fa92d83', __exports__)) {
    api.reload('5fa92d83', __exports__)
  }
  
  module.hot.accept("./video_control.vue?vue&type=template&id=5fa92d83&scoped=true", () => {
    api.rerender('5fa92d83', render)
  })

}


export default __exports__